import MediaIconButton from "@pathwright/legacy-media-manager/src/MediaIconButton"
import Tooltip from "@pathwright/ui/src/components/tooltip/Tooltip"
import React, { useState } from "react"

const CopyLinkButton = ({ link }) => {
  const [isCopied, toggleCopied] = useState(false)
  const [toggleTimeout, setToggleTimeout] = useState(null)

  // Clear timeouts from copy function below
  React.useEffect(() => () => clearTimeout(toggleTimeout))

  const handleCopy = (str) => () => {
    toggleCopied(false)
    const el = document.createElement("textarea")
    el.value = str
    document.body.appendChild(el)
    el.select()
    document.execCommand("copy")
    document.body.removeChild(el)

    // Timeouts for visual icon state
    // Remember the timeouts.
    setToggleTimeout(
      setTimeout(() => {
        toggleCopied(true)

        setToggleTimeout(
          setTimeout(() => {
            toggleCopied(false)
          }, 2000)
        )
      }, 500)
    )
  }

  return (
    <Tooltip title="Copy link">
      <MediaIconButton
        style={{ marginRight: "10px" }}
        onClick={handleCopy(link)}
        icon={isCopied ? "check" : "copy"}
      />
    </Tooltip>
  )
}

export default CopyLinkButton
